/**
 * Fish-specific CSS injected into the chat card's shadow root alongside the
 * portable citation rules (see control-ai-chat.vue's `injectCitationStyles`).
 * Scoped to `fish-citation-waterbody` rather than a generic "any citation
 * chip" selector, since the portable layer has no shared tag/class contract
 * across citation kinds to hang a selector off of.
 */
export const CITATION_STYLES = `
ai-toolkit-markdown li:has(fish-citation-waterbody) {
  list-style: none;
}

ai-toolkit-markdown li:has(fish-citation-waterbody) + li:has(fish-citation-waterbody) {
  margin-top: var(--ys-spacing-100, 0.5rem);
}
`
